import styled from 'styled-components';

export const LoginRequiredContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 2rem;
  text-align: center;
  gap: 1rem;
  background-color: ${(props) => props.theme.color.chatBg};
`;

export const LoginIcon = styled.svg`
  width: 40px;
  height: 40px;
  color: ${(props) => props.theme.color.chatPanel};
`;

export const LoginTitle = styled.h3`
  margin: 0;
  font-size: ${(props) => props.theme.font.size.medium};
  color: ${(props) => props.theme.color.chatHeading};
  font-weight: ${(props) => props.theme.font.weight.semiBold};
`;

export const LoginMessage = styled.p`
  margin: 0;
  font-size: ${(props) => props.theme.font.size.small};
  color: ${(props) => props.theme.color.assistantMessage};
  opacity: 0.8;
`;

export const LoginButton = styled.a`
  display: inline-block;
  padding: 0.75rem 1.5rem;
  background-color: ${(props) => props.theme.color.reaction};
  color: white;
  text-decoration: none;
  border-radius: 4px;
  font-weight: ${(props) => props.theme.font.weight.medium};
  margin-top: 0.5rem;
  transition: background-color 0.2s;
  font-size: ${(props) => props.theme.font.size.default};

  &:hover {
    opacity: 0.9;
    filter: brightness(0.95);
  }

  &:active {
    transform: translateY(1px);
  }
`;

